import { InboxOutlined } from '@ant-design/icons';
import { Modal, Upload } from 'antd';

import { useAppDispatch, useAppSelector } from '@/core/redux/hooks';
import { airExchangeTableActions } from '@/core/redux/slices/airExchangeTable/slice';
import { systemModalsSelectors } from '@/core/redux/slices/modals/smokeExtraction/system/selectors';
import { systemModalsActions } from '@/core/redux/slices/modals/smokeExtraction/system/slice';
import { systemCalculationsActions } from '@/core/redux/slices/smokeExtraction/system/calculations/slice';

const ModalContent: React.FC = () => {
  const dispatch = useAppDispatch();

  const { isRender, payload } = useAppSelector(
    systemModalsSelectors.importFromBIMModal
  );

  const handleCancel = () => {
    dispatch(systemModalsActions.closeImportFromBIMModal());
  };

  const action = (info: any) => {
    if (payload?.typeAction === 'airExchangeTable') {
      dispatch(
        airExchangeTableActions.importJSON({
          id: payload?.systemID,
          formData: { file: info?.file },
        })
      );
    } else if (payload?.typeAction === 'Aerodynamics') {
      dispatch(
        systemCalculationsActions.importJSON({
          id: payload?.systemID,
          formData: { file: info?.file },
        })
      );
    }
  };

  return (
    <Modal
      open={isRender}
      destroyOnClose
      onCancel={handleCancel}
      centered
      title='Импорт файла'
      footer={null}
      width={751}
    >
      <Upload.Dragger multiple beforeUpload={() => false} onChange={action}>
        <p className='ant-upload-drag-icon'>
          <InboxOutlined />
        </p>
        <p className='ant-upload-text'>
          <span className='underline'>Нажмите</span> или перетащите файл, чтобы
          загрузить
        </p>
        <p className='ant-upload-hint'>Загрузите файл BIM</p>
      </Upload.Dragger>
    </Modal>
  );
};

export const ImportFromBIMModal: React.FC = () => {
  const { isRender } = useAppSelector(systemModalsSelectors.importFromBIMModal);

  if (isRender) {
    return <ModalContent />;
  }

  return null;
};
